import { PlanTier } from '@flagsync/skyline';
import * as z from 'zod';

import { JobTitleCode } from '@/services/types';

export type RegisterFormValues = z.infer<typeof registerFormSchema>;

export const registerFormSchema = z.object({
  planTier: z.nativeEnum(PlanTier, {
    errorMap: () => {
      return { message: 'Select a plan to continue' };
    },
  }),
  email: z.coerce.string().email({
    message: 'Please enter a valid email address',
  }),
  password: z.string().min(1, {
    message: 'This field is required',
  }),
  firstName: z.string().min(1, {
    message: 'This field is required',
  }),
  lastName: z.string().min(1, {
    message: 'This field is required',
  }),
  organizationName: z.string().min(1, {
    message: 'This field is required',
  }),
  jobTitle: z.nativeEnum(JobTitleCode, {
    errorMap: () => {
      return { message: 'Please select your job title' };
    },
  }),
  cfTurnstileResponse: z.string(),
});
